import { PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { HomeVo } from "src/vo/homeVo";
import { createSlice } from "@reduxjs/toolkit";
import { AsVo } from "src/vo/asVo";
import { useEffect } from "react";

// vo 객체 활용
const initialState: AsVo = {
  progress: 0,
};

// 2. slice 생성 : createSlice
const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    asListSet: (state, action: PayloadAction<AsVo[] | undefined>) => {
      state.asDataList = action.payload;
    },
    estimateListSet: (state, action: PayloadAction<AsVo[] | undefined>) => {
      state.estimateDataList = action.payload;
    },
    completeListSet: (state, action: PayloadAction<AsVo[] | undefined>) => {
      state.completeDataList = action.payload;
    },
    asHopeListSet: (state, action: PayloadAction<AsVo[] | undefined>) => {
      state.asHopeDataList = action.payload;
    },
    homeNoticeListSet: (state, action: PayloadAction<AsVo[] | undefined>) => {
      state.homeNoticeList = action.payload;
    },
  },
});

// 3-1. export actions
export const { asListSet, estimateListSet, completeListSet, asHopeListSet, homeNoticeListSet } = homeSlice.actions;
// 3-2. export default slice.reducer
export default homeSlice.reducer;
